/**
 * Shared constants and helpers for the platform transfer entry (`/platform-transfer`).
 */

export const PLATFORM_TRANSFER_PATH = "/platform-transfer";

const stripTrailingSlashes = (value: string): string =>
  value.replace(/\/+$/, "");

/**
 * Full browser pathname of the transfer route, including the app basename
 * (same `PUBLIC_PATH` basename logic as `utils/history`).
 */
export const getPlatformTransferPath = (): string =>
  `${stripTrailingSlashes(
    process.env.PUBLIC_PATH || ""
  )}${PLATFORM_TRANSFER_PATH}`;

/**
 * True when the given browser pathname (default: the current one) is the transfer route.
 */
export const isPlatformTransferPath = (
  pathname: string = window.location.pathname
): boolean => stripTrailingSlashes(pathname) === getPlatformTransferPath();
